import { render } from "./dialog1.vue?vue&type=template&id=8f5fbf12&scoped=true"
import script from "./dialog1.vue?vue&type=script&lang=js"
export * from "./dialog1.vue?vue&type=script&lang=js"

import "./dialog1.vue?vue&type=style&index=0&id=8f5fbf12&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5fbf12"]])

export default __exports__